import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'statusLabel',
  standalone: true
})
export class StatusLabelPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(status: any): string {
    // Handle API status values (PurchaseRequestResultDTO.StatusEnum)
    if (typeof status === 'string') {
      const statusMap: { [key: string]: string } = {
        'PENDING': 'purchase_request.status.pending',
        'APPROVED': 'purchase_request.status.approved',
        'REJECTED': 'purchase_request.status.rejected',
        // Legacy statuses
        'PENDING_APPROVAL': 'purchase_request.status.pending_approval'
      };
      
      const translationKey = statusMap[status] || `purchase_request.status.${status.toLowerCase()}`;
      return this.translateService.instant(translationKey);
    }
    
    // Handle raw API status values (boolean or null) - fallback
    if (status === true) {
      return this.translateService.instant('purchase_request.status.approved');
    } else if (status === false) {
      return this.translateService.instant('purchase_request.status.rejected');
    } else if (status === null || status === undefined) {
      return this.translateService.instant('purchase_request.status.pending');
    }
    
    return '';
  }
}

@Pipe({
  name: 'statusStyle',
  standalone: true
})
export class StatusStylePipe implements PipeTransform {
  transform(status: any): any {
    const statusStyles: { [key: string]: any } = {
      'PENDING': {
        'background-color': '#fef3c7',
        color: '#d97706',
        border: 'none',
      },
      'APPROVED': {
        'background-color': '#ecfdf5',
        color: '#047857',
        border: 'none',
      },
      'REJECTED': {
        'background-color': '#fee2e2',
        color: '#dc2626',
        border: 'none',
      },
      // Legacy statuses
      'PENDING_APPROVAL': {
        'background-color': '#fef3c7',
        color: '#d97706',
        border: 'none',
      },
    };

    // Handle API status values (PurchaseRequestResultDTO.StatusEnum)
    if (typeof status === 'string') {
      return statusStyles[status] || {
        'background-color': '#f9fafb',
        color: '#6b7280',
        border: 'none',
      };
    }
    
    // Handle raw API status values (boolean or null) - fallback
    if (status === true) {
      return statusStyles['APPROVED'];
    } else if (status === false) {
      return statusStyles['REJECTED'];
    } else if (status === null || status === undefined) {
      return statusStyles['PENDING'];
    }
    
    return {
      'background-color': '#f9fafb',
      color: '#6b7280',
      border: 'none',
    };
  }
}
